import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";

// Thunk to book an appointment
export const book_appointment = createAsyncThunk(
  "appointments/book_appointment",
  async (appointmentData, { rejectWithValue, fulfillWithValue }) => {
    try {
      const response = await api.post("/book-appointment", appointmentData, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      });
      return fulfillWithValue(response.data);
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Unexpected error occurred"
      );
    }
  }
);

// Existing get_appointment_by_doctor_id Thunk
export const get_appointment_by_doctor_id = createAsyncThunk(
  "appointments/get_appointment_by_doctor_id",
  async (doctorId, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get(`/get-appointment-byid/${doctorId}`, {
        withCredentials: true,
      });
      //console.log(data);
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const get_all_appointments = createAsyncThunk(
  "appointments/get_all_appointments",
  async (role, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get(`/get-all-appointments`, role, {
        withCredentials: true,
      });
      //console.log(data);
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const get_admin_appointments = createAsyncThunk(
  "appointments/get_admin_appointments",
  async (
    { parPage, page, searchId },
    { rejectWithValue, fulfillWithValue }
  ) => {
    try {
      const { data } = await api.get(
        `/admin/get-admin-appointments?page=${page}&parPage=${parPage}&searchId=${searchId}`,
        { withCredentials: true }
      );
      //console.log(data);
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const edit_appointment = createAsyncThunk(
  "appointments/edit_appointment",
  async ({ appointmentId, updatedData }, { rejectWithValue }) => {
    try {
      const response = await api.put(
        `/edit-appointment/${appointmentId}`,
        updatedData,
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Unexpected error occurred"
      );
    }
  }
);

export const delete_appointment = createAsyncThunk(
  "appointments/delete_appointment",
  async (appointmentId, { rejectWithValue }) => {
    try {
      const response = await api.delete(
        `/delete-appointment/${appointmentId}`,
        {
          withCredentials: true,
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to delete appointment."
      );
    }
  }
);

export const appointmentReducer = createSlice({
  name: "appointments",
  initialState: {
    successMessage: "",
    errorMessage: "",
    loader: false,
    appointment: "",
    doctorAppt: [],
    doctorTotalAppointments: 0,
    appointments: [],
    totalApointments: 0,
    pendingAppt: 0,
    acceptedAppt: 0,
    doneAppt: 0,
    refusedAppt: 0,
    totalPaidAmount: 0,
    appointmentsPerPage: [],
    totalAppointmentsPerPage: 0,
  },

  reducers: {
    messageClear: (state) => {
      state.errorMessage = "";
      state.successMessage = "";
    },
  },
  extraReducers: {
    [book_appointment.pending]: (state) => {
      state.loader = true;
      state.errorMessage = "";
      state.successMessage = "";
    },
    [book_appointment.fulfilled]: (state, { payload }) => {
      state.loader = false;
      state.successMessage = payload.message;
    },
    [book_appointment.rejected]: (state, { payload }) => {
      state.loader = false;
      state.errorMessage = payload.message || "Failed to book appointment.";
    },
    [get_appointment_by_doctor_id.fulfilled]: (state, { payload }) => {
      state.doctorTotalAppointments = payload.doctorTotalAppointments;
      state.doctorAppt = payload.doctorAppt;
    },
    [get_all_appointments.fulfilled]: (state, { payload }) => {
      state.totalApointments = payload.totalApointments;
      state.appointments = payload.appointments;
      state.pendingAppt = payload.pendingAppt;
      state.acceptedAppt = payload.acceptedAppt;
      state.doneAppt = payload.doneAppt;
      state.refusedAppt = payload.refusedAppt;
      state.totalPaidAmount = payload.totalPaidAmount;
    },
    [get_admin_appointments.fulfilled]: (state, { payload }) => {
      state.appointmentsPerPage = payload.appointmentsPerPage;
      state.totalAppointmentsPerPage = payload.totalAppointmentsPerPage;
    },
    [edit_appointment.pending]: (state) => {
      state.loader = true;
    },
    [edit_appointment.fulfilled]: (state, { payload }) => {
      state.loader = false;
      state.successMessage = payload.message;

      // Update appointment in the state
      state.doctorAppt = state.doctorAppt.map((appointment) =>
        appointment._id === payload.appointment._id
          ? payload.appointment
          : appointment
      );
    },
    [edit_appointment.rejected]: (state, { payload }) => {
      state.loader = false;
      state.errorMessage = payload.message || "Failed to update appointment.";
    },

    [delete_appointment.pending]: (state) => {
      state.loader = true;
    },
    [delete_appointment.fulfilled]: (state, { payload }) => {
      state.loader = false;
      state.successMessage = payload.message;

      // Remove the deleted appointment from state
      state.doctorAppt = state.doctorAppt.filter(
        (appointment) => appointment._id !== payload.appointmentId
      );
    },
    [delete_appointment.rejected]: (state, { payload }) => {
      state.loader = false;
      state.errorMessage = payload.message || "Failed to delete appointment.";
    },
  },
});

export const { messageClear } = appointmentReducer.actions;
export default appointmentReducer.reducer;
